import type { Feature, FeatureModule } from '../../../../types';
import { featureList } from '../../../helpers';
import { ASSETS_IMAGES_FEATURE_GROUP } from './group';

export const ASSETS_IMAGES_FEATURES = {
  CREATE: {
    guid: 'c2f4a8d1-3b70-4e9c-b831-5d2e7f1a0000',
    name: 'assets:images:create',
    description: 'Upload new images to the asset library',
    action: 'create',
    product: 'account',
    parentGuid: ASSETS_IMAGES_FEATURE_GROUP.guid,
  },
  READ: {
    guid: 'c2f4a8d1-3b70-4e9c-b831-5d2e7f1a0001',
    name: 'assets:images:read',
    description: 'View images in the asset library',
    action: 'read',
    product: 'account',
    parentGuid: ASSETS_IMAGES_FEATURE_GROUP.guid,
  },
  UPDATE: {
    guid: 'c2f4a8d1-3b70-4e9c-b831-5d2e7f1a0002',
    name: 'assets:images:update',
    description: 'Replace or re-tag images in the asset library',
    action: 'update',
    product: 'account',
    parentGuid: ASSETS_IMAGES_FEATURE_GROUP.guid,
  },
  DELETE: {
    guid: 'c2f4a8d1-3b70-4e9c-b831-5d2e7f1a0003',
    name: 'assets:images:delete',
    description: 'Remove images from the asset library',
    action: 'delete',
    product: 'account',
    parentGuid: ASSETS_IMAGES_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { ASSETS_IMAGES_FEATURE_GROUP } from './group';

export const ASSETS_IMAGES_MODULE: FeatureModule = {
  product: 'account',
  groups: [ASSETS_IMAGES_FEATURE_GROUP],
  features: featureList(ASSETS_IMAGES_FEATURES),
};
